import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'ip-shared-pdf-viewer-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, NgxExtendedPdfViewerModule],
  templateUrl: 'pdf-viewer-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerDialogComponent {
  @Input({ required: true }) pdfSrc!: string;
  @Input({ required: true }) visible!: boolean;
  @Input({ required: true }) headerTxt!: string;
  @Output() readonly visibleChange = new EventEmitter<boolean>();

  onVisibleChange(visible: boolean) {
    this.visibleChange.emit(visible);
  }
}
